module.exports = __webpack_public_path__ + "img/徐川副研究员.8ac4b553.jpg";